import { InputText } from 'primereact/inputtext';
import React from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import "./sefazConfigurationForm.scss"
import log from "../../../assets/images/integrationIcons/icones/log.png"

export const SefazConfigurationForm = (props) => {

    // console.log("PROPS", props)
    let dotColorCte = "silver"
    let dotColorNfeSaida = "silver"
    let dotColorNfeEntrada = "silver"

    if (props?.logCte?.records?.length >= 0 && props?.logCte?.records[0]?.status === "OK") {
        dotColorCte = "green"
    } else if (props?.logCte?.records?.length >= 0 && props?.logCte?.records[0]?.status === "ERRO") {
        dotColorCte = "red"
    }

    if (props?.currentRecord?.statusNfeSaida === "OK") {
        dotColorNfeSaida = "green"
    } else if (props?.currentRecord?.statusNfeSaida === "ERRO") {
        dotColorNfeSaida = "red"
    }

    if (props?.logNfe?.records?.length >= 0 && props?.logNfe?.records[0]?.status === "OK") {
        dotColorNfeEntrada = "green"
    } else if (props?.logNfe?.records?.length >= 0 && props?.logNfe?.records[0]?.status === "ERRO") {
        dotColorNfeEntrada = "red"
    }

    return (
        <div className="p-grid" style={{ marginTop: "20px" }}>
            <div className="p-col-3 form-field-container">
                <div style={{ display: "flex", alignItems: "center" }}>
                    <h1>Configuração de CT-e</h1>
                    <span className={`notification-dot-title ${dotColorCte}`} style={{ zIndex: 10 }} />
                </div>
                <hr style={{ marginBottom: "10px", border: "1px solid #002060" }} />
                <p style={{
                    color: "black",
                    marginTop: "10px",
                    marginBottom: "10px",
                    fontSize: "18px",
                    fontWeight: "bold"
                }}>
                    Usaremos o certificado da matriz para buscarmos o CT-e direto na SEFAZ. O certificado serve como um
                    protocolo de autenticação na SEFAZ. Caso desejar que busquemos o CT-e de sua filial,
                    informe o certificado do mesmo também.
                </p>
                <label
                    htmlFor="file-upload"
                    style={{
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        border: "1px solid #A6A6A6",
                        padding: "0.5em 1em",
                        borderRadius: "8px",
                        marginTop: "30px"
                    }}
                >
                    <span style={{ fontWeight: "bold", color: "black" }}>Certificado PFX</span>
                    <i className="pi pi-upload" style={{ marginLeft: "auto" }}></i>
                </label>
                <input id="file-upload" type="file" accept='.pfx' style={{ display: "none" }} onChange={(e) => { props.uploadPFXCteHandler(e); e.target.value = null; }} />
                <InputText type='password' value={props.passwordCtePFX} placeholder="Senha do certificado PFX" style={{ marginTop: "10px", borderRadius: "8px" }} onChange={props.setPasswordCtePFX} />
                <button onClick={props.showDialogCteError} disabled={dotColorCte === "red" ? false : true} className={`lognex-btn-highlighted-inverse custom-button-log ${props.dialogCteError.visible ? "active" : null}`} >
                    <span className="button-label-log">Acessar LOG</span>
                    <div className="button-content-log">
                        <img src={log} alt="NFe" className="icon-button-log" />
                    </div>
                    <span className={`notification-dot ${dotColorCte}`} style={{ zIndex: 10 }} />

                </button>
            </div>

            <div className='p-col-3 form-field-container' style={{ marginLeft: "100px" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <h1> Configuração de NF-e Entrada  </h1>
                    <span className={`notification-dot-title ${dotColorNfeEntrada}`} style={{ zIndex: 10 }} />
                </div>
                <hr style={{ marginBottom: "10px", border: "1px solid #002060" }} />
                <p style={{
                    color: "black",
                    marginTop: "10px",
                    fontSize: "18px",
                    fontWeight: "bold"
                }}>
                    Usaremos o certificado da matriz para buscarmos a NF-e direto na SEFAZ. O certificado serve como um
                    protocolo de autenticação na SEFAZ. Caso desejar que busquemos a NF-e de sua filial,
                    informe o certificado do mesmo também.
                </p>
                <label
                    htmlFor="file"
                    style={{
                        marginTop: "40px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        border: "1px solid #A6A6A6",
                        padding: "0.5em 1em",
                        borderRadius: "8px"
                    }}
                >
                    <span style={{ fontWeight: "bold", color: "black" }}>Certificado PFX</span>
                    <i className="pi pi-upload" style={{ marginLeft: "auto" }}></i>
                </label>
                <input id="file" type="file" accept='.pfx' style={{ display: "none" }} onChange={(e) => { props.uploadPFXHandler(e); e.target.value = null; }} />
                <InputText value={props.passwordNfePFX} type='password' placeholder="Senha do certificado PFX" style={{ marginTop: "10px", borderRadius: "8px" }} onChange={props.passwordPFXHandler} />

                <button onClick={props.showDialogNfeError} disabled={dotColorNfeEntrada === "red" ? false : true} className={`lognex-btn-highlighted-inverse custom-button-log ${props.dialogNfeError.visible ? "active" : null}`} >
                    <span className="button-label-log">Acessar LOG</span>
                    <div className="button-content-log">
                        <img src={log} alt="NFe" className="icon-button-log" />
                    </div>
                    <span className={`notification-dot ${dotColorNfeEntrada}`} style={{ zIndex: 10 }} />
                </button>
            </div>

            <div className='p-col-3 form-field-container' style={{ marginLeft: "100px" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <h1 > Configuração de NF-e Saída </h1>
                    <span className={`notification-dot-title ${dotColorNfeSaida}`} style={{ zIndex: 10 }} />
                </div>
                <hr style={{ marginBottom: "10px", border: "1px solid #002060" }} />
                <p style={{
                    color: "black",
                    marginBottom: "10px",
                    marginTop: "10px",
                    fontSize: "18px",
                    fontWeight: "bold"
                }}>
                    Em seu ERP, configure o seguinte CNPJ no
                    parâmetro autXML: 32466967000150.
                </p>

                <button disabled={dotColorNfeSaida === "red" ? false : true} className="lognex-btn-highlighted-inverse  custom-button-log custom-button.inactive" >
                    <span className="button-label-log ">Acessar LOG</span>
                    <div className="button-content-log">
                        <img src={log} alt="NFe" className="icon-button-log" />
                    </div>
                    <span className={`notification-dot ${dotColorNfeSaida}`} style={{ zIndex: 10 }} />

                </button>
            </div>

            {/* NFE */}
            <Dialog
                header={
                    <div className="lxButtonDialogHeader">
                        <div className="lxHeaderTitle">
                            <i className="pi pi-exclamation-triangle error-icon"> </i>
                            <h3>{props.dialogNfeError.header}</h3>
                        </div>
                        <button
                            className="p-dialog-titlebar-icon p-link lxHeaderClose"
                            onClick={props.hideDialogNfeError}
                        >
                            <span className="pi pi-times"></span>
                        </button>
                    </div>
                }
                closable={false}
                visible={props.dialogNfeError.visible}
                modal={props.dialogNfeError.modal}
                onHide={props.hideDialogNfeError}
            >
                <DataTable
                    resizableColumns={true}
                    columnResizeMode="fit"
                    // rowClassName={this.rowClassName}
                    value={props.logNfe.records}
                    // selectionMode={this.props.isMultiple ? "multiple" : "single"}
                    metaKeySelection={false}
                    // selection={this.state.selection}
                    // onSelectionChange={this.onSelectionChange}
                    // onFilter={this.onFilter}
                    // onSort={this.onSort}
                    // onPage={this.onPage}
                    lazy={true}
                    // totalRecords={this.props.totalRecords}
                    // sortOrder={this.props.order}
                    // sortField={this.props.sortField}
                    // paginator={this.props.paginator}
                    // first={this.props.first}
                    // rows={this.props.rows || 15}
                    emptyMessage="Não foram encontrados registros"
                    scrollable={true}
                    scrollHeight="370px"
                // rowsPerPageOptions={this.props.rowsPerPageOptions || [5, 10, 15]}
                >
                    {props.columns}
                </DataTable>

            </Dialog>
            {/* CTE */}
            <Dialog
                header={
                    <div className="lxButtonDialogHeader">
                        <div className="lxHeaderTitle">
                            <h3>{props.dialogCteError.header}</h3>
                        </div>
                        <button
                            className="p-dialog-titlebar-icon p-link lxHeaderClose"
                            onClick={props.hideDialogCteError}
                        >
                            <span className="pi pi-times"></span>
                        </button>
                    </div>
                }
                closable={false}
                visible={props.dialogCteError.visible}
                modal={props.dialogCteError.modal}
                onHide={props.hideDialogCteError}
            >
                <DataTable
                    resizableColumns={true}
                    columnResizeMode="fit"
                    // rowClassName={this.rowClassName}
                    value={props.logCte.records}
                    // selectionMode={this.props.isMultiple ? "multiple" : "single"}
                    metaKeySelection={false}
                    // selection={this.state.selection}
                    // onSelectionChange={this.onSelectionChange}
                    // onFilter={this.onFilter}
                    // onSort={this.onSort}
                    // onPage={this.onPage}
                    lazy={true}
                    // totalRecords={this.props.totalRecords}
                    // sortOrder={this.props.order}
                    // sortField={this.props.sortField}
                    // paginator={this.props.paginator}
                    // first={this.props.first}
                    // rows={this.props.rows || 15}
                    emptyMessage="Não foram encontrados registros"
                    scrollable={true}
                    scrollHeight="370px"
                // rowsPerPageOptions={this.props.rowsPerPageOptions || [5, 10, 15]}
                >
                    {props.columns}
                </DataTable>

            </Dialog>
        </div>
    )
}       